module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAJBAMAAAB6TJkbAAAAKlBMVEUAAAD///////////////////////////////////////////////////+Gu8ovAAAADXRSTlMA8NCfMBBgUOCPb0AgVvqaCgAAADVJREFUGNNjwA6sGPAA7rum+KQLLzngkWXRFcOnOfiuAT7pxEsH8JndKw4k7+IGE/DKXgoAALVoN21O06KLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_more_white.png
// module id = 9mKx
// module chunks = 21